function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00547 36.0252C6.47213 32.4982 4.98048 28.1732 4.98048 23.5C4.98048 11.6259 14.6107 2 26.4902 2C38.3698 2 48 11.6259 48 23.5C48 35.3741 38.3698 45 26.4902 45C22.4056 45 18.5868 43.862 15.3341 41.8858C10.8709 44.6554 5.76857 43.6687 2.57352 42.5415C1.66197 42.22 1.89968 40.9372 2.84519 40.7362C5.38093 40.1973 8.48705 38.9431 9.00547 36.0252Z",
  stroke: "#FFB800",
  strokeWidth: 4
});

var SvgLeftDialog = function SvgLeftDialog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftDialog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leftDialog.3d2f995e.svg";
export { ForwardRef as ReactComponent };